module.exports = __webpack_public_path__ + "static/media/background2.0261859a.png";